import { render, staticRenderFns } from "./H-1-9__WhereToBuyEdit.vue?vue&type=template&id=74d5ce22&"
import script from "./H-1-9__WhereToBuyEdit.vue?vue&type=script&lang=js&"
export * from "./H-1-9__WhereToBuyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
